import { render, staticRenderFns } from "./ModuloShortcodesContrato.vue?vue&type=template&id=965d7910"
import script from "./ModuloShortcodesContrato.vue?vue&type=script&lang=js"
export * from "./ModuloShortcodesContrato.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports